const requestExitTorNodesInterval = 1000 * 60 * 60;


export {
    requestExitTorNodesInterval
}